import { Component, OnInit, Injector } from '@angular/core';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { OrganizationSecretariesAffiliationService } from 'app/core/http/services/organization-secretaries-affiliation.service';
import { OrganizationService } from 'app/core/http/services/organization.service';
import {
  paginationI,
  paginationInitialState,
  tabI,
} from 'app/core/interfaces/layout';
import { organizationI } from 'app/core/interfaces/organization';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { OrganizationSecretariesLinkComponent } from './bond/organization-link.component';
import { OrganizationSecretariesDetailsComponent } from './details/organization-details.component';

@Component({
  selector: 'organization-secretaries',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
})
export class OrganizationSecretariesComponent
  extends BaseComponent
  implements OnInit
{
  public organizations: organizationI[] = [];
  public title = 'Instituições';
  public tabs: tabI[] = [];
  public pagination: paginationI = paginationInitialState;

  public organizationActive: organizationI[] = [];
  public organizationInactive: organizationI[] = [];
  public organizationWaiting: organizationI[] = [];

  public organizationActivePaginated: any[] = [];
  public organizationInactivePaginated: organizationI[] = [];
  public organizationWaitingPaginated: organizationI[] = [];
  public nextLatLong: [number, number] = [0, 0];

  public locations: any[] = [];
  public affiliations: any[] = [];

  public secretaryLogged: any = {};

  constructor(
    private injector: Injector,
    private organizationService: OrganizationService,
    private locationService: OrganizationLocationService,
    private AffiliationService: OrganizationSecretariesAffiliationService
  ) {
    super(injector);
    this.initTabs();
  }

  async ngOnInit() {
    this.secretaryLogged = this.getUserLogged();

    await this.getAffiliations();

    this.getOrganizations();
    this.getLocations();
    this.getPaginationCount();
  }

  transformFhirToModel(jsonData: any[]) {
    const transformedFhir = jsonData.map((item) => {
      const {
        affiliation_id,
        request: { id: secretary_id, display: secretary_name },
        subject: { id: organization_id, display: organization_name },
        status,
      } = item;

      return {
        affiliation_id,
        secretary_name,
        secretary_id,
        organization_name,
        organization_id,
        status,
      };
    });

    return transformedFhir;
  }

  getAffiliations() {
    this.AffiliationService.listBySecretary(this.secretaryLogged.id).subscribe({
      next: (resAffiliations: any) => {
        this.affiliations = this.transformFhirToModel(resAffiliations);

        this.getOrganizationsActive();
        this.getOrganizationsWaiting();
        this.getOrganizationsInactive();
      },
      error: (err) => {
        console.log('erro', err);

        this.openSnackBar(
          'Falha ao listar as vinculações. Atualize a página novamente!',
          'error'
        );
      },
    });
  }

  getLocations() {
    this.locationService.list().subscribe({
      next: (resLocation: any) => {
        this.locations = resLocation;
      },
      error: (err) => {
        console.log('erro', err);
      },
    });
  }

  getCity(organization_id: string) {
    const location = this.locations.find(
      (location) =>
        location.managingOrganization?.organization_id === organization_id
    );

    if (!location) return null
    
    return `${location?.address[0]?.city}/${location?.address[0]?.state}` || null;
  }

  getAddress(organization_id: string) {
    const location = this.locations.find(
      (location) =>
        location.organization_id === organization_id
    );
    return location?.address[0] || null;
  }

  getOrganizations() {
    this.organizationService.list().subscribe({
      next: (resOrganizatgion: any) => {
        this.organizations = resOrganizatgion;
        console.log(this.organizations);
      },
      error: (err) => {
        console.log('erro', err);
      },
    });
  }

  getOrganizationsActive() {
    const organizations = [...this.affiliations];
    this.organizationActive = organizations.filter(
      (item: any) => item.status == 'accepted'
    );

    this.organizationActivePaginated = organizations.filter(
      (item: any, index: number) =>
        item.status == 'accepted' &&
        index <= this.pagination.limit * this.pagination.page
    );
  }

  getOrganizationsInactive() {
    const organizations = [...this.organizations];
    this.organizationInactive = organizations.filter(
      (item: any) => item.status == 'rejected'
    );
    this.organizationInactivePaginated = organizations.filter(
      (item: any, index: number) =>
        item.active === false &&
        index <= this.pagination.limit * this.pagination.page
    );
  }

  getOrganizationsWaiting() {
    const organizations = [...this.affiliations];
    this.organizationWaiting = organizations.filter(
      (item: any) => item.status == 'requested'
    );

    this.organizationWaitingPaginated = organizations.filter(
      (item: any, index: number) =>
        item.status == 'requested' &&
        index <= this.pagination.limit * this.pagination.page
    );
  }

  getPaginationCount() {}

  paginate(pagination: paginationI) {
    this.pagination = pagination;
    this.getOrganizationsActive();
    this.getOrganizationsInactive();
    this.getOrganizationsWaiting();
  }

  async openOrganizationDetailForm(organization: any) {
    await this.getOrganizationLocation(organization);
    const data = {
      title: organization.organization_name,
      param: {
        id: organization.organization_id,
        location: this.getAddress(organization.organization_id),
        latLong: this.nextLatLong,
      },
    };

    this.dialog.openComponentDialog(
      OrganizationSecretariesDetailsComponent,
      data
    );
  }

  getOrganizationLocation(organization: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const organizationId = organization.organization_id;

      this.locationService.showByOrganization(organizationId).subscribe({
        next: (resOrganizationLocation) => {
          this.nextLatLong = [
            resOrganizationLocation.position.latitude ?? 0,
            resOrganizationLocation.position.longitude ?? 0,
          ];
          resolve();
        },
        error: (err) => {
          console.log(err);
          reject(err);
        },
      });
    });
  }

  openForm() {
    const data = {
      title: 'Vincular nova instituição',
      param: { location: this.locations, affiliations: this.affiliations },
    };

    this.dialog
      .openComponentDialog(OrganizationSecretariesLinkComponent, data)
      .subscribe({
        next: (resfreshComponent: Boolean) => {
          if (resfreshComponent) {
            this.getAffiliations();

            this.getOrganizations();
            this.getLocations();
            this.getPaginationCount();
          }
        },
      });
  }

  getContent(tabId: number) {
    switch (tabId) {
      case 2:
        return this.organizationInactive;
      case 3:
        return this.organizationWaiting;
      default:
        return this.organizationActive;
    }
  }

  getContentPaginated(tabId: number) {
    switch (tabId) {
      case 2:
        return this.organizationInactivePaginated;
      case 3:
        return this.organizationWaitingPaginated;
      default:
        return this.organizationActivePaginated;
    }
  }

  showPagination(tabId: number) {
    const list = this.getContent(tabId);
    return list.length > this.pagination.limit * this.pagination.page;
  }

  initTabs() {
    this.tabs = [
      {
        id: 1,
        title: 'Ativas',
      },
      {
        id: 2,
        title: 'Inativas',
      },
    ];

    this.tabs.push({
      id: 3,
      title: 'Aguardando aprovação',
    });
  }
}
